import React, { useContext, useState } from 'react';
import { AuthContext } from '@/App';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SubscriptionPage = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    if (!user) {
      navigate('/');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const originUrl = window.location.origin;
      
      const response = await axios.post(
        `${API}/checkout/session`,
        {
          package_id: 'monthly',
          origin_url: originUrl
        },
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          withCredentials: true
        }
      );

      // Redirect to Stripe
      window.location.href = response.data.url;
    } catch (error) {
      console.error('Subscription error:', error);
      toast.error('Erreur lors de la création de l\'abonnement');
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-content">
          <a href="/" className="navbar-logo" data-testid="navbar-logo">LE REGISTRE</a>
          <div className="navbar-menu">
            <a href="/" className="navbar-link" data-testid="home-link">Journal</a>
            {user && (
              <div className="navbar-user">
                {user.picture && <img src={user.picture} alt={user.name} className="user-avatar" data-testid="user-avatar" />}
                <span className="user-name" data-testid="user-name">{user.name}</span>
                {user.subscription_status === 'premium' && (
                  <span className="premium-badge" data-testid="premium-badge">Accès étendu</span>
                )}
                <button onClick={logout} className="btn btn-outline" data-testid="logout-button">Déconnexion</button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Subscription Content */}
      <div className="subscription-container">
        {user?.subscription_status === 'premium' ? (
          <div className="subscription-card" data-testid="premium-status-card">
            <h2>Accès étendu actif</h2>
            <p className="subscription-note">
              L'intégralité des archives du Registre vous est ouverte.
            </p>
            {user.subscription_expires_at && (
              <p className="subscription-note" style={{ color: 'var(--accent)' }}>
                Accès valide jusqu'au {new Date(user.subscription_expires_at).toLocaleDateString('fr-FR')}
              </p>
            )}
            <button onClick={() => navigate('/')} className="btn btn-primary" style={{ marginTop: '2rem' }} data-testid="explore-button">
              Consulter le journal
            </button>
          </div>
        ) : (
          <div className="subscription-card" data-testid="subscribe-card">
            <h2>Accès étendu au Registre</h2>
            <p className="subscription-note">
              L'accès étendu ouvre les archives complètes. Il approfondit la lecture — il ne remplace jamais l'observation.
            </p>
            <div className="subscription-price" data-testid="subscription-price">
              $9.99<span> / mois</span>
            </div>
            <ul className="subscription-features">
              <li data-testid="feature-1">Archives complètes : logs, données brutes, notes de méthode</li>
              <li data-testid="feature-2">Chapitres longs de chaque entrée du journal</li>
              <li data-testid="feature-3">Documents et médias en pleine résolution</li>
              <li data-testid="feature-4">Contexte étendu sur les mesures en cours</li>
              <li data-testid="feature-5">Accès prioritaire aux nouvelles entrées</li>
            </ul>
            <button
              onClick={handleSubscribe}
              className="btn btn-primary"
              disabled={loading || !user}
              data-testid="subscribe-button"
            >
              {loading ? 'Traitement…' : user ? 'Étendre mon accès' : 'Identification requise'}
            </button>
            {!user && (
              <p className="subscription-note">
                Un accès observateur est requis pour étendre vos droits de lecture.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionPage;
